import api from "./request"
// import axios from 'axios'

const service = {
  //注册：register、登录：login、忘记密码：forget、修改密码：modify
  //获取短信验证码
  getMobileCode ({mobile, type}) { 
    let params = new URLSearchParams()
    params.append('mobile', mobile)
    params.append('captcha_type', type)
    return fetch('qimen?op=getMobileCode',
      params,  
      'post')   
  },
  getRegister ({mobile, captcha, type, token, password}) {
    let params = new URLSearchParams()
    params.append('mobile', mobile)
    params.append('captcha', captcha)
    params.append('captcha_type', type)
    params.append('token', token)
    params.append('password', password)
    return fetch('qimen?op=getRegister',
      params,  
      'post')  
  },
  getLogin ({mobile, password}) {
    let params = new URLSearchParams()
    params.append('mobile', mobile) 
    params.append('password', password)
    return fetch('qimen?op=getLogin',
      params,  
      'post')  
  },
  forgetPassword ({mobile, captcha, type, token, password}) {
    let params = new URLSearchParams()
    params.append('mobile', mobile)
    params.append('captcha', captcha)
    params.append('captcha_type', type)
    params.append('token', token)
    params.append('new_password', password)
    return fetch('qimen?op=forgetPassword',
      params,  
      'post')  
  },

  getForumThread(){
    return fetch('qimen?op=getForumThread')
  },
  getLogout (token) {  
    api.interceptors.request.use(
      config=>{ 
          config.headers = {
            'token': token,  
          } 
          return config;
      }, 
      error=>{
          console.log(error);
          Promise.reject(error);
      }
    )
    
    return api.post("qimen?op=getLogout") 
  },
  checkLogin (token) {   
    api.interceptors.request.use(
      config=>{ 
          config.headers = {
            'token': token,  
          } 
          return config;
      }, 
      error=>{
          console.log(error);
          Promise.reject(error);
      }
    )
    return api.post("qimen?op=checkLogin") 
  },

}

export default service

export async function fetch (url, body, options, method = 'post') { 
  try {
    let res
    if (method === 'get') {
      res = await api.get(url, { params: body }, options)
    } else {
      res = await api.post(url, body, options)
    }
    const data = res // .json()
    // if (data.code === 401 && state.userInfo) {
    //   // Session 失效 
    // }
    if (data.code == 200) {
      data.code = 0
    }
    if (data.code && !data.message) {
      data.message = 'Error ' + data.code
    }
    return data
  } catch (err) { 
    if (err.url && err.status === 0) {
      return {
        code: -1, 
        data: null
      }
    }
    return {
      code: -2, 
      data: null
    }
  }
}